module.exports = __webpack_public_path__ + "img/pethouse29.2eeb2278.jpg";